import { useEffect, useState } from "react";

export function useCanRender3D() {
  const [ok, setOk] = useState(false);
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const small = window.matchMedia("(max-width: 767px)").matches;
    let webgl = false;
    try {
      const c = document.createElement("canvas");
      webgl = !!(c.getContext("webgl2") || c.getContext("webgl"));
    } catch (e) {
      webgl = false;
    }
    setOk(!reduced && !small && webgl);
  }, []);
  return ok;
}
